import { PropsWithChildren } from "react";
import { getAwsRumConfig } from "./config";
import { MonitoringContext } from "./useMonitoring";
import { AwsRum } from "aws-rum-web";

export const MonitoringProvider = ({
  children,
}: PropsWithChildren<unknown>) => {
  let awsRum: AwsRum | undefined = undefined;
  let sessionId: string | undefined = undefined;
  try {
    console.log("Will setup AWS Rum");
    awsRum = getAwsRumConfig();
    awsRum.addPlugin({
      getPluginId: () => "FrontendAnalyticsIntegration",
      load: (context) => {
        sessionId = context.getSession()?.sessionId;
      },
      enable: () => {},
      disable: () => {},
    });
  } catch (error) {
    console.error(error);
  }

  const updateMonitoringPrincipalId = (principalId: string) => {
    awsRum?.addSessionAttributes({
      principalId: principalId,
    });
  };

  return (
    <MonitoringContext.Provider
      value={{
        awsRum: awsRum as AwsRum,
        updateMonitoringPrincipalId,
        sessionId,
      }}
    >
      {children}
    </MonitoringContext.Provider>
  );
};
